































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { ConviteUsuario } from '../../../../back/src/entity/ConviteUsuario';
import { ConviteUsuarioNovoFormData } from '../../../../back/src/types';

import CustomDialog from '../CustomDialog.vue';

export default Vue.extend({
  name: 'TheConvitesUsuariosModalNovoConvite',
  components: {
    CustomDialog,
  },
  props: {
    block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      errorMessagesEmail: [] as string[],
      form: {
        email: '',
      },
      rules: {
        email: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            const emailPattern: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return (v && emailPattern.test(v)) || 'E-mail inválido';
          },
        ],
      },
    };
  },
  computed: {
    formEmail(): Vue & { validate: () => boolean } {
      return this.$refs.formEmail as Vue & { validate: () => boolean };
    },
  },
  methods: {
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      if (!this.formEmail.validate()) {
        this.loading = false;
        return;
      }
      const formData: ConviteUsuarioNovoFormData = {
        email: this.form.email,
      };
      try {
        const response = await Requester.conviteUsuario.criaConviteUsuario(formData);
        if (response.errors.length > 0) {
          this.errorMessagesEmail = response.errors;
        } else {
          this.$emit('novoConvite', response.data);
          this.$root.$emit('avisoSnackbar', {
            color: 'success',
            text: 'Convite enviado com sucesso!',
          });
          this.form.email = '';
          this.dialog = false;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
  },
});
